import { useCallback, useEffect } from 'react';
import { useAtom, atom } from 'jotai';

import { Channel } from '../components/RichTextEditor';

export const channelState = atom<Channel | null>(null);

export const useChannel = () => {
  return useAtom(channelState);
};

export const useChannelPick = (defaultChannel?: Channel | null) => {
  const [channel, setChannel] = useChannel();

  const handleChannelChange = useCallback(
    (channel: Channel | null) => {
      setChannel(channel);
    },
    [setChannel],
  );

  useEffect(() => {
    if (typeof defaultChannel !== 'undefined') {
      setChannel(defaultChannel);
    }
    // eslint-disable-next-line
  }, [defaultChannel]);

  return {
    defaultChannel,
    channel,
    channelId: channel?.id,
    handleChannelChange,
  };
};
